<template>
  <div id="home">
    <div class="banner">
     <el-carousel  trigger="click" :height="imgHeight+'px'" :autoplay='false'>
      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="bannerImg" ref="imgHeight"  @load="imgLoad">
          <div class="imgBox">
            <div class="text">
              <div class="title">{{$t(item.text)}}<img class="imglog" :src="item.imglog" alt=""></div>
              <div class="detail">
                {{$t(item.detail)}}
              </div>
            </div>
            <img class="smallimg" :src="item.smallimg" alt="">
          </div>
      </el-carousel-item>
    </el-carousel>
    </div>
    <div class="content1" >
      <el-row class="con" :gutter="10"  style="margin: 0 auto;">
        <el-col :xs="6" :sm="6" :lg="6" v-for="item in con1" :key="(item.tit,item.con)">
          <div class="box wow fadeInUp" :data-wow-duration="item.duration" data-wow-delay="0.5s">
            <div><img :src="item.src" alt=""></div>
            <div class="tit">{{$t(item.tit)}}</div>
            <div class="con">{{$t(item.con)}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content2">
      <img class="imgBg" src="/static/images/home/pos/con3_bg.png" alt="">
      <div class="con">
        <div class="top">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :lazy='true' :label="$t('home.con2.title1')" name="one">
              <div class="box">
                <div class="imgBox">
                  <img src="/static/images/home/pos/con3.png" alt="">
                  <div v-show="selectId==0">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/pos/con3_1_1.png" alt=""></div>
                    <div class="smallImg2"  v-show='show'><img src="/static/images/home/pos/con3_1_2.png" alt=""></div>
                    <div class="smallImg3"  v-show='show'><img src="/static/images/home/pos/con3_1_3.png" alt=""></div>
                    <div class="smallImg4"  v-show='show'><img src="/static/images/home/pos/con3_1_4.png" alt=""></div>
                    <div class="smallImg5"  v-show='show'><img src="/static/images/home/pos/con3_1_5.png" alt=""></div>
                  </div>
                  <div v-show="selectId==1">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/pos/con3_1_1.png" alt=""></div>
                    <div class="smallImg2" v-show='show'><img src="/static/images/home/pos/con3_2_1.png" alt=""></div>
                  </div>
                  <div v-show="selectId==2">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/pos/con3_3_1.png" alt=""></div>
                    <div class="smallImg2" v-show='show'><img src="/static/images/home/pos/con3_3_2.png" alt=""></div>
                    <div class="smallImg3" v-show='show'><img src="/static/images/home/pos/con3_3_3.png" alt=""></div>
                    <div class="smallImg4" v-show='show'><img src="/static/images/home/pos/con3_3_4.png" alt=""></div>
                    <div class="smallImg5" v-show='show'><img src="/static/images/home/pos/con3_3_5.png" alt=""></div>
                    <div class="smallImg6" v-show='show'><img src="/static/images/home/pos/con3_3_6.png" alt=""></div>
                  </div>
                  <div v-show="selectId==3">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/pos/con3_4_1.png" alt=""></div>
                    <div class="smallImg2"  v-show='show'><img src="/static/images/home/pos/con3_4_2.png" alt=""></div>
                    <div class="smallImg3"  v-show='show'><img src="/static/images/home/pos/con3_4_3.png" alt=""></div>
                    <div class="smallImg4"  v-show='show'><img src="/static/images/home/pos/con3_4_4.png" alt=""></div>
                  </div>
                </div>
                <div class="conBoxList">
                  <div class="list" v-for="(item,index) in contentList1" :key='(item.title,item.titleSub,item.con)' @mouseover="conBoxShow(index)" @mouseleave="conBoxHidden(index)">
                    <div class="conBox" :class="index==selectId?'active':''" >
                      <div class="conBoxTitle">{{$t(item.title)}}</div>
                       <transition name="slide-fade" >
                         <div  v-show="index==selectId">
                            <div class="conBoxTitleSub">{{$t(item.titleSub)}}</div>
                            <div class="conBoxCon">{{$t(item.con)}}</div>
                        </div>
                        </transition>
                    </div>
                  </div>
                  <div class="list conBoxBtn">
                    <router-link :to="{path:'/Software'}">
                    <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
                    </router-link>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :lazy='true' :label="$t('home.con2.title2')" name="two">
              <div class="box">
                <div class="imgBox">
                  <img src="/static/images/home/web/con3.png" alt="">
                  <div v-show="selectId==0">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/web/con3_1_1.png" alt=""></div>
                    <div class="smallImg2"  v-show='show'><img src="/static/images/home/web/con3_1_2.png" alt=""></div>
                    <div class="smallImg3"  v-show='show'><img src="/static/images/home/web/con3_1_3.png" alt=""></div>
                    <div class="smallImg4"  v-show='show'><img src="/static/images/home/web/con3_1_4.png" alt=""></div>
                  </div>
                  <div v-show="selectId==1">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/web/con3_2_1.png" alt=""></div>
                    <div class="smallImg2" v-show='show'><img src="/static/images/home/web/con3_2_2.png" alt=""></div>
                    <div class="smallImg3" v-show='show'><img src="/static/images/home/web/con3_2_3.png" alt=""></div>
                  </div>
                  <div v-show="selectId==2">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/web/con3_3_1.png" alt=""></div>
                    <div class="smallImg2" v-show='show'><img src="/static/images/home/web/con3_3_2.png" alt=""></div>
                    <div class="smallImg3" v-show='show'><img src="/static/images/home/web/con3_3_3.png" alt=""></div>
                  </div>
                  <div v-show="selectId==3">
                    <div class="smallImg1" v-show='show'><img src="/static/images/home/web/con3_4_1.png" alt=""></div>
                    <div class="smallImg2"  v-show='show'><img src="/static/images/home/web/con3_4_2.png" alt=""></div>
                    <div class="smallImg3"  v-show='show'><img src="/static/images/home/web/con3_4_3.png" alt=""></div>
                    <div class="smallImg4"  v-show='show'><img src="/static/images/home/web/con3_4_4.png" alt=""></div>
                  </div>
                </div>
                <div class="conBoxList">
                  <div class="list" v-for="(item,index) in contentList2" :key='(item.title,item.titleSub,item.con)'  @mouseover="conBoxShow(index)" @mouseleave="conBoxHidden(index)">
                    <div class="conBox" :class="index==selectId?'active':''">
                      <div class="conBoxTitle">{{$t(item.title)}}</div>
                      <transition name="slide-fade" >
                         <div  v-show="index==selectId">
                            <div class="conBoxTitleSub">{{$t(item.titleSub)}}</div>
                            <div class="conBoxCon">{{$t(item.con)}}</div>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div class="list conBoxBtn">
                    <router-link :to="{path:'/Hardware'}">
                    <div class="moreBtn"> {{$t('home.moreBtn')}} <img src="/static/images/common/bt_more.png" alt=""></div>
                    </router-link>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="content3">
      <!-- <div class="con">
        <div class="box">
          <div class="imgBox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
            <img class="con3Img" src="/static/images/home/con4_1.png" alt="">
            <div class="conText">
                <div class="tit">{{$t("home.con3.tit")}}</div>
                <div class="titSub">{{$t("home.con3.titSub")}}</div>
                <div class="list conBoxBtn">
                  <router-link :to="{path:'/Blog'}">
                    <div class="moreBtn"> {{$t("home.moreBtn")}} <img src="/static/images/common/bt_more.png" alt=""></div>
                  </router-link>
                </div>
            </div>
          </div>
          <div class="imgBox wow fadeInUp" data-wow-duration="1.2s" data-wow-delay="0.5s">
            <img class="con3Img" src="/static/images/home/con4_2.png" alt="">
          </div>
        </div>
        <div class="box boxBottom">
          <div class="imgBox wow fadeInUp" :data-wow-duration="item.duration" data-wow-delay="0.5s" :class="textShow==index?'shadowSelect':''" v-for="(item,index) in con3List" :key="(item.tit,item.text,item.titSub,index)" @mouseover="TextShow(index)" @mouseleave="TextHidden()">
            <div class="showText">
              <img class="con3Img"  :src="item.src" alt="">
                 <transition name="el-fade-in-linear">
                  <router-link :to="{path:'/BlogDetail'}">
                    <div class="text" v-show="textShow==index">{{$t("home.con3.detail")}}<img src="/static/images/common/bt_more.png" alt=""></div>
                  </router-link>
                </transition>
            </div>
            <div class="con3Text">
              <div class="tit">Merchant background</div>
              <div class="titSub">Remotely manage and synchronize data on table occupancy, menu…</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="con shop">
        <div class="title">{{$t("home.con3.tit")}}</div>
        <div><img src="/static/images/home/con4_6.svg" alt=""></div>
        <div class="flexBox">
          <div class="boxs">
            <div class="tit">{{$t("home.con3.titSub")}}</div>
            <div class="detail">{{$t("home.con3.detail")}}</div>
          </div>
          <div class="boxs"><img src="/static/images/home/con4_7.png" alt=""></div>
        </div>
      </div>
    </div>
    <div class="content4">
        <img class="con4Img" src="/static/images/home/con5_bg.png" alt="">
        <div class="con">
          <div class="box">
            <div class="left">
              <div class="tit">
                {{$t("home.con4.tit1")}}
              </div>
              <div class="list conBoxBtn">
                <router-link :to="{path:'/About'}">
                  <div class="moreBtn"> {{$t("home.moreBtn")}} <img src="/static/images/common/bt_more.png" alt=""></div>
                </router-link>
              </div>
            </div>
            <div class="right">
              <div class="tit">{{$t("home.con4.tit2")}}</div>
              <div class="conText">{{$t("home.con4.titSub")}}</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { WOW } from 'wowjs';
export default {
  data() {
    return {
      imgHeight: '150px',
      imgHeights: '150px',
      bannerList:[
        {
          img:'/static/images/home/con1_1.png',
          smallimg:'/static/images/home/con1_1_1.png',
          imglog:'/static/images/home/con1_1_2.png',
          text:'home.banner.banner1.bannerText',
          detail:'home.banner.banner1.bannerDetail'
        },
        {
          img:'/static/images/home/con1_2.png',
          smallimg:'/static/images/home/con1_2_1.png',
          text:'home.banner.banner2.bannerText',
          detail:'home.banner.banner2.bannerDetail',
          imglog:''
        }
      ],
      activeName: 'one',
      boxShow:false,
      selectId:0,
      show:false,
      textShow:null,
      menuShow:false,
      con1:[
        {
          tit:'home.con1.tit1',
          con:'home.con1.con1',
          src:'/static/images/home/con2_1.png',
          duration:'1s'
        },
        {
          tit:'home.con1.tit2',
          con:'home.con1.con2',
          src:'/static/images/home/con2_2.png',
          duration:'1.2s'
        },
        {
          tit:'home.con1.tit3',
          con:'home.con1.con3',
          src:'/static/images/home/con2_3.png',
          duration:'1.4s'
        },
        {
          tit:'home.con1.tit4',
          con:'home.con1.con4',
          src:'/static/images/home/con2_4.png',
          duration:'1.6s'
        },
      ],
      contentList1:[
        {
          title:'home.con2.table1.title1',
          titleSub:'home.con2.table1.titleSub1',
          con:'home.con2.table1.con1',
        },
       {
          title:'home.con2.table1.title2',
          titleSub:'home.con2.table1.titleSub2',
          con:'home.con2.table1.con2',
        },
       {
          title:'home.con2.table1.title3',
          titleSub:'home.con2.table1.titleSub3',
          con:'home.con2.table1.con3',
        },
       {
          title:'home.con2.table1.title4',
          titleSub:'home.con2.table1.titleSub4',
          con:'home.con2.table1.con4',
        },
      ],
      contentList2:[
        {
          title:'home.con2.table2.title1',
          titleSub:'home.con2.table2.titleSub1',
          con:'home.con2.table2.con1',
        },
       {
          title:'home.con2.table2.title2',
          titleSub:'home.con2.table2.titleSub2',
          con:'home.con2.table2.con2',
        },
       {
          title:'home.con2.table2.title3',
          titleSub:'home.con2.table2.titleSub3',
          con:'home.con2.table2.con3',
        },
       {
          title:'home.con2.table2.title4',
          titleSub:'home.con2.table2.titleSub4',
          con:'home.con2.table2.con4',
        },
      ],
      con3List:[
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_3.png',
          duration:'1.4s'
        },
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_4.png',
          duration:'1.6s'
        },
        {
          tit:'home.con1.tit1',
          text:'home.con1.tit1',
          src:'/static/images/home/con4_5.png',
          duration:'1.8s'
        }
      ],


    };
  },
  //定义这个sweiper对象
  computed: {},
  mounted() {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: false
    })
    wow.init();
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener('resize', () => {
      this.imgHeight = this.$refs.imgHeight[0].height
      this.imgLoad()
    })
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
     imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.imgHeight[0].height
        this.imgHeights = this.$refs.imgHeight[0].height+65
        // console.log(this.$refs.imgHeight[0].height)
      })
    },
     handleClick(tab, event) {
        // console.log(tab, event);
    },
    conBoxShow(id){
      // console.log('id',id)
      this.selectId =id
      this.show =true
    },
    conBoxHidden(id){
      this.selectId =false
      // this.show =0
    },
    TextShow(id){
      this.textShow =id
    },
    TextHidden(){
      this.textShow =null
    },
    menuShows(){
      this.menuShow = true
    },
    menuHiddens(){
      this.menuShow = false
    },
    onScroll() {
      var scrol = Number($(window).scrollTop()),
        that = this;
      if (scrol < 400) {
        that.menu_active = 5;
      } else if (400 <= scrol && scrol < 1570) {
        that.menu_active = 0;
      } else if (1570 <= scrol && scrol < 4785) {
        that.menu_active = 1;
      } else if (4785 <= scrol && scrol < 5250) {
        that.menu_active = 2;
      } else if (5250 <= scrol && scrol < 5890) {
        that.menu_active = 3;
      } else if (scrol >= 5890) {
        that.menu_active = 4;
      }
    },
    menu_btn(index) {
      var that = this;
      let scrol_top = "";
      if (index == 0) {
        that.menu_active = 5;
        scrol_top = 0;
      } else if (index == 1) {
        that.menu_active = 1;
        scrol_top = 1570;
      } else if (index == 2) {
        that.menu_active = 2;
        scrol_top = 4785;
      } else if (index == 3) {
        that.menu_active = 3;
        scrol_top = 5250;
      } else if (index == 4) {
        that.menu_active = 4;
        scrol_top = 5890;
      }
      $("html,body").animate(
        {
          scrollTop: scrol_top + "px"
        },
        1000
      );
    },
    tj_btn() {
      // var that = this;
      // if (this.name == "") {
      //   layer.msg(that.name_msg);
      //   return false;
      // }
      // if (this.phone == "") {
      //   layer.msg(that.phone_msg);
      //   return false;
      // }
      // if (this.text_con == "") {
      //   layer.msg(that.text_con_msg);
      //   return false;
      // }

      //                that.$http.pos('/h5/user/login', this.$qs.stringify(
      //                    {
      //                        mobile_phone:that.inputValue,
      //                        code:that.verifyCode
      //                    }
      //                ))
      //                    .then(function (response) {
      //                        console.log(response);
      //                        if(response.data.err==1){
      //
      //
      //                        }else{
      //
      //                        }
      //
      //                    })
      //                    .catch(function (response) {
      //
      //                    })
    },
    //   鼠标移入
    mouseEnter(index) {
      this.isActive = index;
    },
    //   鼠标移除1
    mouseLeave() {
      this.isActive = null;
    },

    changeLangEvent() {
      var that = this;
      if (this.$getCookie("langs") == "en") {
        this.$setCookie("langs", "zh");
        this.lang = "zh";
        this.$i18n.locale = this.lang; //关键语句
        that.$router.push("/Home");
        window.location.reload();
      } else {
        this.$setCookie("langs", "en");
        this.lang = "en";
        this.$i18n.locale = this.lang; //关键语句
        that.$router.push("/Home");
        window.location.reload();
      }
    }
  }
};
</script>
<style lang="less" type="text/less">
#home{
 .banner{
    margin-top: 70px;
    .el-carousel__button{
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #ccc;
    }
    .el-carousel__indicator.is-active .el-carousel__button{
      width: 30px;
      height: 15px;
      border-radius: 8px;
    }
  }
  .content2{
    .el-tabs{
      position: relative;
      height: 100%;
    }
    .el-tabs__header{
      padding-top: 5%;
    }
    .el-tabs__nav{
      float: none;
      text-align: center;
      padding:0 0 20px 0;
    }
    .el-tabs__active-bar{
      display: none;
    }
    .el-tabs__item{
      margin-right: 30px;
      font-size: 26px;
      // width: 50%;
      font-weight: bold;
      display: inline-block;
    }
     .el-tabs__item:nth-child(2){
       text-align: right;
       margin-right: 10%;
       padding: 0;
     }
     .el-tabs__item:nth-child(3){
       text-align: left;
       margin-left: 10%;
       padding: 0;
     }
    .el-tabs__item:hover{
      color: #FF9600;
    }
    .el-tabs__item.is-active{
      color: #FF9600;
      position: relative;
    }
    .el-tabs__item:nth-child(2).is-active::after{
      background: #FF9600;
      content:'';
      display: inline-block;
      height: 4px;
      position: absolute;
      z-index: 12;
      bottom: -20px;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
    }
    .el-tabs__item:nth-child(3).is-active::after{
      background: #FF9600;
      content:'';
      display: inline-block;
      height: 4px;
      position: absolute;
      z-index: 12;
      bottom: -20px;
      left: 0;
      left: 0;
      margin: auto;
      width: 100%;
    }
    .el-tabs__nav-wrap::after{
      height: 4px;
    }
    .el-tabs__content{
      position:absolute;
      bottom:0;
      height: 100%;
    }
    .el-tab-pane{
      height: 100%;
    }
  }
}
</style>
<style scoped lang="less" type="text/less">
#home{
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .navbar{
    height: 65px;
    line-height: 65px;
    background: #fff;
    width: 100%;
    text-align: center;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 100;
    .nav{
      width: 60%;
      min-width: 960px;
      margin: 0 auto;
      font-size: 16px;
      display: flex;
      justify-content: flex-start;
      position: relative;
      li{
        display: inline-block;
        padding: 0 15px;
        color: #666;
        &:hover{
          cursor: pointer;
        }
        &.active{
          color: #333;
          font-weight: bold;
        }
        &.languageBtn{
          padding-left: 80px;
          font-size: 14px;
          position: absolute;
          right: 60px;
        }
        span{
          position: relative;
          top: 3px;
        }
      }
    }
  }
  .navMenu{
    position:fixed;
    width: 100%;
    left: 0;
    z-index: 8;
    background: #fff;
    padding: 36px 0;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    .con{
      width: 60%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .left,.right{
        display: flex;
        justify-content: center;
        align-items: center;
        .menuImg{
          margin-right: 30px;
        }
        .title{
          color: #333;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          left: -16px;
        }
        .titleSub{
          padding-top: 10px;
          ul li{
            color: #999;
            font-size: 12px;
            line-height: 24px;
            list-style: disc;
          }
        }
      }
    }
  }
  .banner{
    margin-top: 65px;
    position: relative;
    // position: fixed;
    // z-index: -1;
    // top: 0;
    // width: 100%;
    .bannerImg{
      width: 100%;
    }
    .imgBox{
      width: 60%;
      margin:auto;
      position: absolute;
      left: 15px;
      right: 0;
      top: 30%;
      .smallimg{
        //  width: 50%;
      }
      .imglog{
        margin-left: 10px;
      }
      .text{
          .title{
            font-size: 38px;
            color: #333;
            font-weight: bold;
          }
          .detail{
            font-size: 22px;
            color: #666;
            padding: 20px 0 30px 0;
            width: 50%;
            line-height: 40px;
          }
      }
    }
  }
  .content1{
    width: 70%;
    margin: 0 auto;
    padding: 120px 0px;
    text-align: center;
    background: #fff;
    // display: flex;
    // justify-content: space-between;
    // align-items: flex-start;
    .con{
      width: 100%;
      margin: 0 auto;
      .box{
        padding: 0 15px 15px 15px;
        .tit{
          color: #333;
          font-size: 16px;
          font-weight: bold;
          padding: 20px 0 10px 0;
        }
        .con{
          color: #999;
          font-size: 13px;
        }
      }

    }
  }
  .content2{
    min-height: 600px;
    .imgBg{
      width: 100%;
      min-height: 600px;
    }
    position: relative;
    .con{
      position: absolute;
      top: 0;
      left:0;
      right:0;
      margin: auto;
      width: 80%;
      height: 100%;
      .top{
        width: 100%;
        margin: 0 auto;
        // padding-top: 6%;
      height: 100%;
      }
      .box{
        display: flex;
        height: 100%;
        justify-content: space-between;
        align-items: flex-end;
        .imgBox{
          position: relative;
          width: 50%;
          min-width: 440px;
          bottom: 0;
          img{
            width: 100%;
            max-width: 646px;
          }
          .smallImg1{
            position:absolute;
            z-index: 1;
            top:50%;
            animation:myfirst1 1.5s;
            -webkit-animation:myfirst1 1.5s;
            animation-fill-mode: forwards;
          }
          .smallImg2{
            position:absolute;
            z-index: 2;
            top:50%;
            animation:myfirst2 1.7s;
            -webkit-animation:myfirst2 1.7s;
            animation-fill-mode: forwards;
          }
          .smallImg3{
            position:absolute;
            z-index: 3;
            top:50%;
            animation:myfirst3 1.9s;
            -webkit-animation:myfirst3 1.9s;
            animation-fill-mode: forwards;
          }
          .smallImg4{
            position:absolute;
            z-index: 4;
            top:50%;
            animation:myfirst4 2.1s;
            -webkit-animation:myfirst4 2.1s;
            animation-fill-mode: forwards;
          }
          .smallImg5{
            position:absolute;
            z-index: 4;
            top:50%;
            animation:myfirst5 2.3s;
            -webkit-animation:myfirst5 2.3s;
            animation-fill-mode: forwards;
          }
          .smallImg6{
            position:absolute;
            z-index: 4;
            top:50%;
            animation:myfirst6 4s;
            -webkit-animation:myfirst6 4s;
            animation-fill-mode: forwards;
          }
          @-webkit-keyframes myfirst1 {
              0%   {top:50%; opacity: 0;}
              25%   {top:12.5%; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
           @-webkit-keyframes myfirst2 {
              0%   {top:50%; opacity: 0;}
              25%   {top:25%; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
           @-webkit-keyframes myfirst3 {
              0%   {top:50%; opacity: 0;}
              25%   {top:25%; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
           @-webkit-keyframes myfirst4 {
              0%   {top:50%; opacity: 0;}
              25%   {top:25%; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
           @-webkit-keyframes myfirst5 {
              0%   {top:50%; opacity: 0;}
              25%   {top:25%; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
           @-webkit-keyframes myfirst6 {
              0%   {top:0; opacity: 0;}
              50%   {top:0; opacity: 0;}
              100% {top:0; opacity: 1;}
          }
        }
        .conBoxList{
          align-self: flex-start;
          margin-top: 14%;
          height: 70%;
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          align-content:space-between;
          justify-content: center;
          .list{
            width: 100%;
          }
          .conBoxBtn{
            margin-top: 20px;
            .moreBtn{
              background: #27C2B4;
              box-shadow:0px 3px 6px rgba(11,128,117,0.26);
              border-radius:22px;
              display: inline-block;
              padding: 8px 30px 7px 30px;
              color: #fff;
              margin-left: 26px;
              cursor: pointer;
              img{
                position: relative;
                top: -2px;
              }
            }
          }
          .conBox{
            .slide-fade-enter-active {
              transition: all .3s ease;
            }
            .slide-fade-leave-active {
              transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
            }
            .slide-fade-enter, .slide-fade-leave-to
            /* .slide-fade-leave-active for below version 2.1.8 */ {
              transform: translateX(10px);
              opacity: 0;
            }
            padding: 20px 30px 20px 60px;
            cursor: pointer;
            display: inline-block;
            // width: 100%;
            &.active{
              background: #fff;
              border-radius:10px;
              box-shadow:0px 3px 14px rgba(0,0,0,0.1);
              margin-bottom: 15px;
              width: auto;
              .conBoxTitle{
                color: #333;
                font-weight: bold;
                font-size: .5rem;
                margin-left: -.8rem;
              }
              .conBoxTitleSub{
                display: inline-block;
                color: #333;
                font-weight: bold;
                font-size: .42rem;
                padding: 10px 0;
              }
              .conBoxCon{
                display: inline-block;
                color: #666;
                font-size: .4rem;
              }
            }
             .conBoxTitle{
                color: #666;
                font-weight: bold;
                font-size: .5rem;
                margin-left: -36px;
              }
              .conBoxTitleSub{
                display: none;
                color: #333;
                font-weight: bold;
                font-size: .42rem;
                padding: 10px 0;
              }
              .conBoxCon{
                display: none;
                color: #666;
                font-size: .4rem;
              }

          }
        }
      }
    }
  }
  .content3{
    width: 60%;
    margin: 0 auto;
    padding: 140px 0;
    .con{
      width: 100%;
      margin: 0 auto;
      .box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        &.boxBottom{

          .imgBox{
            border:1px solid rgba(221,221,221,1);
            box-shadow:0px 4px 10px rgba(0,0,0,0.05);
            cursor: pointer;
            &.shadowSelect{
              box-shadow:0px 4px 10px rgba(0,0,0,0.15);
            }
            .showText{
              position: relative;
              overflow: hidden;
              .text{
                color: #fff;
                width: 100%;
                position:absolute;
                bottom:0;
                left: 0;
                background:rgba(37,183,170,0.8);
                padding: 15px;
                img{
                  position:absolute;
                  right:40px;
                }
              }
            }
            .con3Text{
              padding: 30px 20px;
              .tit{
                color: #333;
                font-size: 18px;
                font-weight: bold;
              }
              .titSub{
                color: #999;
                font-size: 16px;
                padding: 10px 0 0;
              }
            }
          }

        }
        .imgBox{
          margin-right: 10px;
          position: relative;
          .conText{
            position:absolute;
            width: 60%;
            top: 20%;
            left:8%;
            .tit{
              font-size: 30px;
              font-weight: bold;
              color: #333;
            }
            .titSub{
              font-size: 18px;
              color: #333;
              padding: 20px 0;
            }
            .conBoxBtn{
              margin-top: 20px;
              .moreBtn{
                background: #27C2B4;
                box-shadow:0px 3px 6px rgba(11,128,117,0.26);
                border-radius:22px;
                display: inline-block;
                padding: 8px 30px 7px 30px;
                color: #fff;
                cursor: pointer;
                img{
                  position: relative;
                  top: -2px;
                }
              }
            }
          }
        }
        .imgBox:last-child{
          margin-right: 0px;
        }
        .con3Img{
          width: 100%;
          // max-width: 100%;
        }
      }
    }
    .shop{
      img{
        width: 100%;
      }
      .title{
        font-size: 24px;
        font-weight: bold;
        color: #333;
      }
      .flexBox{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .boxs{
          width: 49%;
          position: relative;
          .tit{
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin-bottom: 10px;
          }
          &:last-child::before{
            content:'';
            border-left: 2px solid #e6e6e6;
            position:absolute;
            height: 70%;
            left: -30px;
            top: 18%;
          }
        }
      }
    }
  }
  .content4{
    position: relative;
    min-height: 360px;
    .con4Img{
      width: 100%;
      min-height: 360px;
    }
    .con{
      position: absolute;
      top: 0;
      left:0;
      right:0;
      margin: auto;
      width: 60%;
      // height: 100%;
      padding: 6% 0;
      .box{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .left{
          width: 50%;
          .tit{
            font-size: 30px;
            color: #333;
            font-weight: bold;
            padding-bottom: 20px;
          }
        }
        .right{
          width: 50%;
          .tit{
            color: #333;
            font-size: 18px;
            font-weight: bold;
            padding-bottom: 20px;
            position: relative;
            &::before{
              content:'';
              display: inline-block;
              width: 2px;
              background: #999;
              height: 40px;
              position: absolute;
              left: -60px;
            }
          }
          .conText{
            font-size: 14px;
            color: #999;
          }
        }
        .conBoxBtn{
          margin-top: 20px;
          .moreBtn{
            background: #27C2B4;
            box-shadow:0px 3px 6px rgba(11,128,117,0.26);
            border-radius:22px;
            display: inline-block;
            padding: 8px 30px 7px 30px;
            color: #fff;
            cursor: pointer;
            img{
              position: relative;
              top: -2px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue